import type { Chain } from "~/tools/chain";
import type { Defaultable } from "~/tools/defaultable";
import type { Functor } from "~/tools/functor";
import { Matchable } from "~/tools/matchable";

class Idle extends Matchable<"idle"> implements Functor<never>, Chain<never>, Defaultable<never> {
	protected readonly __name = "idle" as const;

	public isIdle(): this is Idle {
		return true;
	}

	public isLoading(): false {
		return false;
	}

	public isFailure(): false {
		return false;
	}

	public isSuccess(): false {
		return false;
	}

	public getOrElse<TFallback>(fallback: TFallback): TFallback {
		return fallback;
	}

	public transform(): this {
		return this;
	}

	public transformFailure(): this {
		return this;
	}

	public chain(): this {
		return this;
	}
}

export { Idle };
